<template>
    <v-dialog
        v-model="isOpen"
        content-class="v-application v-application--is-ltr acceptance-comment-dialog"
        max-width="780px"
        :fullscreen="!$vuetify.breakpoint.mdAndUp"
    >
        <v-card outlined elevation="0" class="rounded v-application">
            <v-card-title>Geolokalisierung aktualisieren</v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; flex: 1 1 auto;">
                <v-row>
                    <v-col cols="9">
                        <v-autocomplete
                            v-model="selectedPharmacies"
                            :items="searchResults"
                            @update:search-input="term => searchPharmacies(term)"
                            label="Suche Apotheke"
                            no-data-text="Geben Sie ein, um Suchergebnisse zu erhaltenKeine Suchergebnisse"
                            :loading="isLoading"
                            chips
                            multiple
                            no-filter
                            return-object
                        >
                            <template v-slot:item="{ item }" class="pharmacy-option">
                                <div
                                    class="v-application"
                                    data-role="pharmacy-option"
                                    :data-pharmacy-id="item._id"
                                >
                                    <div class="font-weight-medium mt-2 no-margin pharmacy-name">
                                        {{item.name }} ({{item.city}})
                                    </div>
                                </div>
                            </template>
                        </v-autocomplete>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-end pa-4">
                <v-btn text @click="isOpen = false">Abbrechen</v-btn>
                <v-btn
                    @click="submit"
                    :disabled="!selectedPharmacies.length"
                    color="success"
                    :loading="isLoading"
                >
                    Speichern
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";

export default {
    props: {
        value: Boolean
    },
    data() {
        return {
            isLoading: false,
            search: '',
            selectedPharmacies: [],
            searchResults: [],
        }
    },
    methods: {
        searchPharmacies: _.debounce(async function (search) {
            if (!search?.trim().length) {
                this.searchResults = [...this.selectedPharmacies];
                return
            }
            try {
                this.isLoading = true;
                const response = await axios.get(`/api/pharmacies/search`, {
                    params: {
                        query: search,
                        query_type: 'active',
                        page: 1,
                        page_size: 10,
                    },
                });
                if (response.data.status >= 400) throw new Error();
                const searchResults = response.data.results.map(pharmacy => ({
                    ...pharmacy,
                    value: pharmacy._id,
                    text:  `${pharmacy.name} (${pharmacy.city})`
                }));
                this.searchResults = [...this.selectedPharmacies, ...searchResults]
            }
            catch (error) {
                this.alertError();
            }
            finally {
                this.isLoading = false;
            }
        }, 200),

        async submit() {
            this.isLoading = true
            try {
                const response = await axios.put('/api/pharmacies/geolocation', {
                    ids: this.selectedPharmacies.map(pharmacy => pharmacy._id)
                });
                const pharmacyNames = response.data.map(({ name }) => name).join(', ');
                this.alertSuccess(`${pharmacyNames} geolokalisierung aktualisiert`)
            } catch {
                this.alertError()
            } finally {
                this.isOpen = false;
                this.isLoading = false
            }
        },

        ...mapMutations({
            alertError: "alert/error",
            alertSuccess: "alert/success",
        }),
    },
    computed: {
        isOpen: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
}
</script>